import fetch from 'isomorphic-fetch'
import { getLegendUrl } from '../mapUtils/LegendUtils'

const fetchUrl = (url) => {
	return fetch(url, {
		method: "GET"
	})
		.then((response) => {
			if (response.status === 200) {
				return url
			}
			return null
		}).catch(() => {
			return null
		})
}
const urlsCheckStatus = (layers) => {
	const result = layers.map((o) => {
		return fetchUrl(getLegendUrl(o))
	})
	return Promise.all(result)
}

export { urlsCheckStatus }



// WEBPACK FOOTER //
// ./src/utils/actions/CheckStatusAction.js